// 1.0 DEFINE CONST
const _document = $(document);
const _window = $(window);
const windowWidth = _window.width();
const windowHeight = _window.height();
const html = $('html');
const body = $('body');

const screenIsTablet = 1024 >= windowWidth 
	? true : false;
const screenIsMobile = 600 >= windowWidth 
	? true : false;
const scrollOffset = screenIsTablet 
	? 100 : 160;

keyOnPress = false;

_document.on('keydown', function() {
	keyOnPress = true;
}).on('keyup', function() {
	keyOnPress = false;
});

scrollTop = 0;
_window.on('load scroll', function() {
	scrollTop = _window.scrollTop();
});

// 2.0 TOOLS/UTILITIES

const scrollTo = (id) => {
	// because # causes issue with product review
	if(id == '#') return false;

	let scrollContainer = html;
	let scrollPosition = typeof id != 'number'
		? id == 'window'
			? windowHeight
			: $(id).length
				? $(id).offset().top
				: 0
		: windowHeight*(id/100)

	if(getComputedStyle(scrollContainer[0]).scrollBehavior === 'smooth') {
		scrollContainer.scrollTop(scrollPosition - scrollOffset);
	} else {
		scrollContainer.animate({
			scrollTop: scrollPosition - scrollOffset
		});
	}
}

const siteReadyTrigger = (punk, delay) => {
	document.addEventListener('readystatechange', event => {
		if (document.readyState == 'complete') {
			(delay) ? setTimeout(punk, delay) : punk();
		}
	});
}

const loadingBarTrigger = (stage) => {
	const loadingBar = $('#loading-bar');

	let action = (loadingBar.css('opacity') == 1 && stage != 'done')
		? 'move' : stage

	switch(action) {
		case 'start':
			loadingBar.css('opacity', 1)
				.width(windowWidth*(Math.floor(Math.random() * 6) + 1)/10);
			break;

		case 'move':
			loadingBar.css('opacity', 1)
				.width(loadingBar.width()*1.15);
			break;

		case 'done':
			loadingBar.width(windowWidth);

			setTimeout(function() {
				loadingBar.css('opacity', 0);
			}, 300);

			setTimeout(function() {
				loadingBar.width(0);
			}, 600);
			break;
	}
}

const formatCommify = (value) => {
	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// 3.0 PAGES/COMPONENTS

const initPageTransition = () => {
	let siteUrl = shopUrl.replace('www.', '').replace('http://', '').replace('https://', '');

	$('a[href]').each(function(){
		let _this = $(this);
		let href = _this.attr('href');

		if((href.includes(siteUrl) || href.startsWith('/')) && 
			_this.attr('target') != '_blank' && !href.includes('mailto:')) {
			_this.attr('data-location', 'internal');

		} else {
			_this.attr('data-location', 'external')
		}
	});

	_document.on('click', 'a[href]', function(e) {
		let _this = $(this);
		let href = _this.attr('href');
		let hrefSplitHash = href.split('#');
		let windowHrefSplitHash = window.location.href.split('#');

		html.removeClass('mobile_menu_active');

		// if hash origin url is current url
		if(href.startsWith('#') || 
			hrefSplitHash[0] == windowHrefSplitHash[0]) {
			e.preventDefault();

			// scroll to hash location
			scrollTo(`#${hrefSplitHash[1]}`);

		} else if(_this.attr('data-location') == 'internal' &&
			keyOnPress == false) {
			e.preventDefault();

			html.addClass('is_leaving');

			setTimeout(function() {
				window.location.href = href;
			}, 300);
		}
	});
}

const initFields = () => {
	let inputs = $(`.field input[type="text"],
		.field input[type="email"], 
		.field input[type="tel"],
		.field input[type="url"],
		.field input[type="password"],
		.field textarea`);
	let select = $('.field select');

	inputs.on('init blur', function() {
		let _this = $(this);

		(_this.val().length > 0) 
			? _this.closest('.field').addClass('has_value') 
			: _this.closest('.field').removeClass('has_value');
	});

	siteReadyTrigger(function() {
		inputs.trigger('init');
	});

	select.on('change', function() {
		let _this = $(this);

		_this.closest('.field').addClass('has_value');
	});
};

const initCompMarquee = () => {
	siteReadyTrigger(function() {
		$('.marquee').each(function() {
			let marquee = $(this);
			let marqueeFactor = Math.ceil(windowWidth/marquee.width())*2;

			if(marqueeFactor != Infinity) {
				marquee.html(`
					${Array(marqueeFactor).join(0).split(0).map((item, i) => `
						<span>${marquee.html()}</span>
					`).join('')}
				`);
			}	
			marquee.css('visibility', 'visible');
		});

		const _marquee = document.querySelectorAll('.marquee');

		_marquee.forEach((carousel, i) => {
			let requestId;
			let playSpeed = (carousel.hasAttribute('data-marquee-speed'))
				? carousel.getAttribute('data-marquee-speed')
				: 1.5;

			const mainTicker = new Flickity(carousel, {
				accessibility: true,
				resize: true,
				wrapAround: true,
				prevNextButtons: false,
				pageDots: false,
				percentPosition: true,
				setGallerySize: true,
				draggable: false
			});

			mainTicker.x = 0;

			setTimeout(function() {
				mainTicker.resize();
				play();
			}, 200);

			function play() {
				mainTicker.x = mainTicker.x - playSpeed;
				mainTicker.settle(mainTicker.x);
				requestId = window.requestAnimationFrame(play);
			}
		});
	}, 100);
}

const initCompFlipboard = () => {
	$('.flipboard').each(function() {
		let flipboard = $(this);
		let flipboardText = flipboard.text().split(',')
			.map(Function.prototype.call, String.prototype.trim);

		flipboard.html('').typer({
            strings: flipboardText,
            backspaceDelay: 3000
        }).css('visibility', 'visible');
	});
}

const initCompSlider = () => {
	$('.comp-slider').each(function() {
		let slider = $(this);

		slider.imagesLoaded(function() {
			slider.flickity({
				cellAlign: slider[0].hasAttribute('data-slider-cellalign') 
					? slider.attr('data-slider-cellalign')
					: 'center',
				wrapAround: slider[0].hasAttribute('data-slider-wraparound') 
					? true : (screenIsMobile)
						? true : false,
				prevNextButtons: slider[0].hasAttribute('data-slider-arrows') 
					? true : false,
				pageDots: slider[0].hasAttribute('data-slider-dots') 
					? true : false,
				draggable: slider[0].hasAttribute('data-slider-draggable')
					? true : (screenIsMobile)
						? true : false,
				contain: true,
				selectedAttraction: 0.1,
				friction: 0.4,
				imagesLoaded: true
			});

			if(!screenIsTablet && 
				slider[0].hasAttribute('data-slider-tablet-only')) {
				slider.flickity('destroy');
			}

			if(!screenIsMobile && 
				slider[0].hasAttribute('data-slider-mobile-only')) {
				slider.flickity('destroy');
			}

			setTimeout(function() {
				slider.addClass('init');
			}, 200);
		});
	});
};

const initCompToggle = () => {
	_document.on('click', '.toggle-label', function() {
		$(this).siblings('.toggle-content').slideToggle()
			.closest('.comp-toggle').toggleClass('active')
			.siblings().removeClass('active')
			.find('.toggle-content').slideUp();
	});
}

const initHeader = () => {
	const mobileMenuTrigger = $('#mobile-menu-trigger');

	mobileMenuTrigger.click(function() {
		html.toggleClass('mobile_menu_active');
	});
}

const activateDropdown = () => {
	const sublinkMenuTrigger = $('#navDropdownTrigger');
	const sublinkMenu = $('#sub-links');
	const sublinkOppositeTrigger = $('#navSecondaryDropdownTrigger');
	const sublinkOppositeMenu = $('#sub-links__secondary');

	sublinkMenuTrigger.mouseenter(function() {
		if(sublinkOppositeTrigger.hasClass('active-dropdown-color')) {
			sublinkOppositeTrigger.removeClass('active-dropdown-color');
			sublinkOppositeMenu.removeClass('isActive');
		}

		sublinkMenuTrigger.toggleClass('active-dropdown-color');
		sublinkMenu.addClass('isActive');
	})

	sublinkMenu.mouseleave(function() {
		sublinkMenuTrigger.toggleClass('active-dropdown-color');
		sublinkMenu.toggleClass('isActive');
	})
}

const activateSecondaryDropdown = () => {
	const sublinkMenuTrigger = $('#navSecondaryDropdownTrigger');
	const sublinkMenu = $('#sub-links__secondary');
	const sublinkOppositeTrigger = $('#navDropdownTrigger');
	const sublinkOppositeMenu = $('#sub-links');

	sublinkMenuTrigger.mouseenter(function() {
		if(sublinkOppositeTrigger.hasClass('active-dropdown-color')) {
			sublinkOppositeTrigger.removeClass('active-dropdown-color');
			sublinkOppositeMenu.removeClass('isActive');
		}

		sublinkMenuTrigger.toggleClass('active-dropdown-color');
		sublinkMenu.addClass('isActive');
	})

	sublinkMenu.mouseleave(function() {
		sublinkMenuTrigger.toggleClass('active-dropdown-color');
		sublinkMenu.toggleClass('isActive');
	})
}

const initFrontpage = () => {
	// hero
	const heroIframe = $('#frontpage-hero iframe');

	if(heroIframe.length) {
		const heroPlayer = new Vimeo.Player(heroIframe[0]);

		heroPlayer.on('loaded', function() {
			heroPlayer.play();
		});
	}

	$('#quiz-popup-trigger').click(function() {
		html.addClass('quiz_popup_active');
	});

	$('#quiz-popup-overlay').click(function() {
		html.removeClass('quiz_popup_active');
	});

	// narrative section
	const narrativeStories = $('#narrative-stories');
	const narrativeStoriesStory = narrativeStories.find('.story');
	const narrativeStoriesMargintop = parseInt(narrativeStoriesStory.css('margin-top'));

	const frontpageScroll = () => {
		let activeIndex = ((scrollTop - narrativeStories.offset().top)/(windowHeight - narrativeStoriesMargintop));

		narrativeStoriesStory.each(function(i) {
			let _this = $(this);

			if(i < narrativeStoriesStory.length - 1) {
				_this.find('.story-content').css('opacity', 
					i + 1 - Number(activeIndex.toFixed(2)));
			}
		});
	}

	if(!screenIsTablet) {
		frontpageScroll();
		_window.scroll(frontpageScroll);
	}

	// download section
	const downloadMockupScreenImg = $('#download-mockup-screen img');
	const downloadContentSlider = $('#download-content-slider .comp-slider');

	downloadContentSlider.on('change.flickity', function(e, i) {
		let appMockup = $(downloadContentSlider.find('.slide')[i]).attr('data-app-mockup');

		downloadMockupScreenImg.attr('src', appMockup)
			.attr('srcset', '');
	});

	// social section
	const instagramFeed = $('#instagram-feed').empty();
	const instaAccessToken = 'IGQVJYS3N2c04wRkVUbkNhYnB3LUdPVHlycTZAEZAzUyWFpjNHZAIZAkFXRkpraHNZAUnJEbEUwQmY3QWVoWU1HbVJBeDN0SWZAONjFrOW5TM3ljNzNmQ3R4eWM3TnhkLW5lWjlUZAEF0bjIzOGJaOG5lY2JvXwZDZD';

	if(instaAccessToken) {
		userFeed = new Instafeed({
			get: 'user',
			userId: 26172632094,
			accessToken: instaAccessToken,
			target: 'instagram-feed',
			limit: (screenIsMobile) ? 1 : 6,
			resolution: 'standard_resolution',
			template: `<div class="post">
				<a class="object-fit" href="{{link}}" target="_blank"><img src="{{image}}"></a></div>
			</div>`,
			after: function() {
				instagramFeed.addClass('css_fadeIn');
			}
		});

		userFeed.run();
	}
}

const productIndex = () => {
	const selectItems = $('#select-items');

	$('.item-cover, .item-sidebar').click(function() {
		$(this).closest('.item').addClass('active')
			.siblings().removeClass('active');

		selectItems.addClass('is-selected');
	});

	const selectTabTrigger = $('[data-item-tab-trigger]');
	const selectTab = $('[data-select-tab]');

	selectTabTrigger.click(function() {
		let _this = $(this);

		_this.addClass('active')
			.siblings().removeClass('active');

		$(`[data-select-tab="${_this.attr('data-item-tab-trigger')}"]`).addClass('active')
			.siblings().removeClass('active')
	}).first().click();

	const paidPlanMonthly = document.querySelector('#paid-plan-option-monthly');
	const paidPlanAnnual = document.querySelector('#paid-plan-option-annual');

	const addRechargeAttr = (loadedOption) => {
		if (loadedOption === paidPlanMonthly) {
			$(paidPlanMonthly).attr('data-variant-id');
			$(paidPlanMonthly).attr('data-quickadd-properties', `{
				"shipping_interval_unit_type": "${$(paidPlanMonthly).attr('data-variant-interval-unit')}",
				"shipping_interval_frequency":  "${$(paidPlanMonthly).attr('data-variant-interval-value')}"
			}`)
		} else if (loadedOption === paidPlanAnnual) {
			$(paidPlanAnnual).attr('data-variant-id');
			$(paidPlanAnnual).attr('data-quickadd-properties', `{
				"shipping_interval_unit_type": "${$(paidPlanAnnual).attr('data-variant-interval-unit')}",
				"shipping_interval_frequency": "${$(paidPlanAnnual).attr('data-variant-interval-value')}"
			}`)
		}
	}

	if (paidPlanMonthly !== null) {
		addRechargeAttr(paidPlanMonthly);
	};
	
	if (paidPlanAnnual !== null) {
		addRechargeAttr(paidPlanAnnual);
	}

	// reviews 
	$('.spr-summary-actions-newreview').click(function() {
		scrollTo('#product-reviews');
	});
}

const initProductQuickview = () => {
	$('[data-quickview-trigger]').click(function() {
		html.addClass('quickview_active');

		$(`.product-quickview[data-quickview="${$(this).attr('data-quickview-trigger')}"]`).addClass('active')
	});

	$('.product-quickview').remove().clone().appendTo(body);
	body.append(`<div id="product-quickview-overlay"></div>`)

	$('#product-quickview-overlay, .quickview-close').click(function() {
		html.removeClass('quickview_active');

		$('[data-quickview].active').removeClass('active');
	});

	$('.quickview-content').each(function() {
		let _this = $(this);
		let quickadd = _this.find('[data-quickadd-id]');

		_this.find('.item-quantity button').click(function(e) {
			setTimeout(function() {
				quickadd.attr('data-quickadd-quantity', 
					_this.find('.item-quantity-current').text());
			}, 100);
		});

		_this.find('[data-variant-id]').click(function() {
			$(this).addClass('active')
				.siblings().removeClass('active');

			quickadd.attr('data-quickadd-id', 
				$(this).attr('data-variant-id'));
		});
	});
}

const initCart = () => {
	const minicartTrigger = $('.minicart-trigger');
	const minicartClose = $('#minicart-close, #minicart-overlay, #minicart-empty-close');

	const excludeRecommendedItems = () => {
		$('#cart-items [data-item-id]').each(function() {
			let _this = $(this);

			$(`#minicart-recommend [data-quickadd-id="${_this.attr('data-item-id')}"], #cart-recommend [data-quickadd-id="${_this.attr('data-item-id')}"]`).closest('.minicart-product, .product').hide();
		});
	}

	const cartTotalUpdate = () => {
		let totalPrice = $('.cart-total-price');
		let itemCount = $('.cart-item-count');
		let item = (html.is('#cart'))
			? $('#cart-content .item')
			: $('#minicart-content .item')

		totalPriceChange = 0;
		totalItemCount = 0;

		// loop through each item
		item.each(function() {
			let item = $(this);
			let itemQuantity = item.find('.item-quantity-current').length
				? parseInt($(item.find('.item-quantity-current')[0]).text())
				: 1;
			let itemPrice = item.find('.item-price').length
				? parseInt(item.find('.item-price').text().replace(/[^0-9&.]/g,''))
				: item.attr('data-item-price');

			// multiply price and quantity, and add to total value
			totalPriceChange += itemPrice*itemQuantity;
			totalItemCount += itemQuantity;
		});

		// update cart total values
		totalPrice.text(`$${formatCommify(totalPriceChange.toFixed(2))}`);
		itemCount.text(totalItemCount);

		// determine whether item exists
		if (totalItemCount == 0) {
			$('#cart-content, #minicart').removeClass('has_items');
			html.removeClass('minicart_active');
		} else if (totalItemCount == 1 && item.attr('data-item-price') == 0) {
			//remove free item if only item in cart
			item.remove();
			$.post(`/cart/update.js?updates[${item.attr(`data-item-id`)}]=0`)
			cartTotalUpdate();
		} else {
			$('#cart-content, #minicart').addClass('has_items');
		}

		// remove active states
		html.removeClass('quickview_active');
		$('.product-quickview.active').removeClass('active');

		// remove existing recommended items;
		excludeRecommendedItems();
	}

	const itemUpdate = (variantId, qty, funk) => {
		if (qty != 0) {
			$.post(`/cart/update.js?updates[${variantId}]=${qty}`)
				.always(function() {
					if(funk) {
						funk();
						loadingBarTrigger('move');
					} else {
						setTimeout(cartTotalUpdate, 301);
						loadingBarTrigger('done');
					}
				});
		} else if (qty == 0) {
			loadingBarTrigger('move');
			$.post(`/cart/update.js?updates[${variantId}]=0`)
				.always(function() {
					console.log('item removed');
				})
			loadingBarTrigger('done')
		}
	}

	// clear cart
	const clearCart = () => {
		jQuery.ajax({
			type: 'POST',
			url: '/cart/clear.js',
			success: function() { 
			alert('success!');
			}
		});
	}
	
	// variables removed from below function openCart, reloadPage
	const itemAdd = (id, qty, openCart, reloadPage, properties) => {
		let items = [];
		items.push({
			quantity: qty,
			id: id,
            properties: properties
		})
		
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: { items: items },
			dataType: 'json',

			success: function() {
				loadingBarTrigger('move');

				$.ajax({
					url: '/cart',
					dataType: 'html',
					error: function(data) {
						console.error(data);

						loadingBarTrigger('done');
					},
					success: function(data) {
						let minicartContent = $('#minicart-content');
						let cartItemsHtml = $(data).find('#cart-content #cart-items').html();

						// insert or prepend cart HTML
						(minicartContent.find('#cart-items').length)
							? minicartContent.find('#cart-items').html(cartItemsHtml)
							: minicartContent.prepend(cartItemsHtml);

						// remove giftbox content if exists
						(minicartContent.find('#cart-giftbox .item-info').length)
							? minicartContent.find('#cart-giftbox .item-info').remove()
							: '';

						loadingBarTrigger('done');
						cartTotalUpdate();

						// open cart
						(openCart && !html.is('#cart'))
						? minicartTrigger.trigger('click') : '';
						// (reloadPage)
						// 	? location.reload() : '';
					}
				});
			},
			error: function(XMLHttpRequest) {
				console.log(XMLHttpRequest.responseText);
				loadingBarTrigger('done');
			},
		});
	}

	// add multiple items
	const itemsAddPost = (itemsQueue, openCart) => {
		let data = {
			items: itemsQueue
		}
		loadingBarTrigger('move');
		fetch(`/cart/add.js`, {
			// post data
			body: JSON.stringify(data),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With':'xmlhttprequest'
			},
			method: 'POST'
		}).then((response) => {
			return response.json();
		}).then((json, data) => {
			// get updated cart if successful
			$.ajax({
				url: '/cart',
				dataType: 'html',
				error: function(data) {
					console.error(data);

					loadingBarTrigger('done');
				},
				success: function(data) {
					let minicartContent = $('#minicart-content');
					let cartItemsHtml = $(data).find('#cart-content #cart-items').html();

					// insert or prepend cart HTML
					(minicartContent.find('#cart-items').length)
						? minicartContent.find('#cart-items').html(cartItemsHtml)
						: minicartContent.prepend(cartItemsHtml);

					loadingBarTrigger('done');
					cartTotalUpdate();

					// open cart
					(openCart && !html.is('#cart'))
					? minicartTrigger.trigger('click') : '';
				}
			});

			// open cart
			(openCart && !html.is('#cart'))
			? minicartTrigger.trigger('click') : '';
		}).catch((err) => {
			loadingBarTrigger('done');
			/* uh oh, we have error. */
			console.error(err)
		})
	}

	// remove multiple items
	const itemsRemovePost = (items) => {
  		var qty = 0;
  		var data = { updates: {} };
		
		for (i = 0; i < items.length; i++) {
			data.updates[items[i]] = qty;
		}
		loadingBarTrigger('move');
		jQuery.ajax({
			type: 'POST',
			url: '/cart/update.js',
			data: data,
			dataType: 'json',
			success: function() { 
			  console.log('items removed!');
			}
		});
	}

	//redirect to recharge checkout
	const checkoutProcessRecharge = () => {
		function get_cookie(name) {
			return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] 
		} do {
			token = get_cookie('cart');
		}
		while(token == undefined);

		try {
			var ga_linker = ga.getAll()[0].get('linkerParam')
		} catch(err) {
			var ga_linker =''
		}

		const customerParam = '';

		window.location.href = `https://checkout.rechargeapps.com/r/checkout?myshopify_domain=${siteShopifyDomain}&cart_token=${token}&${ga_linker}&${customerParam}`;
	}

	// quick add
	//Edited by Mo 
	_document.on('click', '[data-quickadd-id]', function() {
		let _this = $(this);
		if (!cartErrorHandler(_this) && !_this.attr('data-quickadd-other-1')) {
			// collections add at botom of page
			itemAdd(
				_this.attr('data-quickadd-id'), 
				// _this.attr('data-quickadd-properties'), 
				(_this.attr('data-quickadd-quantity'))
					? _this.attr('data-quickadd-quantity')
					: 1, 
				(!html.is('#cart')) ? true : false,
				(html.is('#cart')) ? true : false
			);
			return
		} else if (_this.attr('data-quickadd-other-1') == undefined) {	
			loadingBarTrigger('start');
            var form_props = _this.closest('form').find('[name^="properties"]');
          	var add_props = {};
            if( form_props.length ) {
              form_props.each(function(i, e) {
                if ($(this).val() != undefined && $(this).val() != "") {
                  var prop_name = $(this).attr('name');
                  prop_name = prop_name.slice(11, prop_name.length - 1);
                  add_props[prop_name] = $(this).val();                 
                }
              });
            }
			itemAdd(
				_this.attr('data-quickadd-id'), 
				// _this.attr('data-quickadd-properties'), 
				(_this.attr('data-quickadd-quantity'))
					? _this.attr('data-quickadd-quantity')
					: 1, 
				(!html.is('#cart')) ? true : false,
				(html.is('#cart')) ? true : false,
                add_props
			);
		} else {
			loadingBarTrigger('start');
			// check for other items
			if(_this.attr('data-quickadd-other-1') && _this.attr('data-quickadd-other-1') != '') {
				let itemsQueue = []
				// add primary item to queue
				itemsQueue.push(
					{
						'id': _this.attr('data-quickadd-id'),
						'qty': (_this.attr('data-quickadd-quantity')) 
							? _this.attr('data-quickadd-quantity')
							: 1
					}
				)
				// add other items
				for (i=1; i <= 2; i++)  {
					if(_this.attr(`data-quickadd-other-${i}`) != '') {
						itemsQueue.push( {
							'id': _this.attr(`data-quickadd-other-${i}`),
							'qty': (_this.attr(`data-quickadd-other-quantity-${i}`)) 
							? _this.attr(`data-quickadd-other-quantity-${i}`)
							: 1
						})
					} else {
						break;
					}
				}
				(!html.is('#cart')) ? true : false,
				(html.is('#cart')) ? true : false
				// post to cart
				itemsAddPost(
					itemsQueue,
					(!html.is('#cart')) ? true : false,
					(html.is('#cart')) ? true : false
				);
			} else {
				itemAdd(
					_this.attr('data-quickadd-id'), 
					// _this.attr('data-quickadd-properties'), 
					(_this.attr('data-quickadd-quantity'))
						? _this.attr('data-quickadd-quantity')
						: 1, 
					(!html.is('#cart')) ? true : false,
					(html.is('#cart')) ? true : false
				);
			}
		}  
	});

	// display error
	const displayError = (_this, message) => {
		errorDiv = _this.context.previousElementSibling
		errorDiv.textContent = message
	}

	// clear error
	const clearMessage = (_this) => {
		errorDiv = _this.context.previousElementSibling
		errorDiv.textContent = ''
	}

	// add to cart error handler
	const cartErrorHandler = (buttonData) => {
		let topParent = buttonData.context.parentNode.parentNode
		let parentId = topParent.id.toLowerCase()
		let allRadios = topParent.querySelectorAll('input[type="radio"]')
		allRadios = Array.from(allRadios)
		let selectedRadios = []
		let btnListener =  buttonData.context
		for (const radio of allRadios) {
			if (radio.checked) {
				selectedRadios.push(radio.getAttribute('data-variant-id'))
			}
		}
		if (parentId == 'main' || parentId == 'outer') {
			if (selectedRadios.length == 1) {
				console.log('Added to cart')
				clearMessage(buttonData)
				btnListener.setAttribute('listener', 'true');
				return true
			} else {
				displayError(buttonData, 'Complete your selection!')
				btnListener.setAttribute('listener', 'true');
				return false
			}
		} else if (parentId == 'duo' || parentId == 'trio') {
			if (parentId == 'duo') {
				if (selectedRadios.length != 1) {
					displayError(buttonData, 'Complete your selection!')
					btnListener.setAttribute('listener', 'true');
					return false
				} else {
					clearMessage(buttonData)
					return true
				}
			} else if (parentId == 'trio') {
				if (selectedRadios.length != 2) {
					displayError(buttonData, 'Complete your selection!')
					btnListener.setAttribute('listener', 'true');
					return false
				} else {
					clearMessage(buttonData)
					return true
				}
			} else {
				clearMessage(buttonData)
				return true
			}
		}
	}
  
  
	// quick add no cart
	//Edited by Mo  no cart
	_document.on('click', '[nocarthere]', function() {
		let _this = $(this);

		loadingBarTrigger('start');
		itemAddNoCart(
			_this.attr('data-quickaddnocart-id'), 
			// _this.attr('data-quickadd-properties'), 
			(_this.attr('data-quickadd-quantity'))
				? _this.attr('data-quickadd-quantity')
				: 1, 
			
		);
	});
	

	// disabling due to no longer offering subscription - Jason R
	// _document.on('click', '[data-item-subscription]', function(e) {
	// 	// when checkout button is triggered
	// 	const cartTerms = $('#cart-terms');

	// 	cartTerms.change(function() {
	// 		$(this).parent().removeClass('error');
	// 	});
	// 		e.preventDefault();
	// 		checkoutProcessRecharge();
			
	// });
		
		
	_document.on('click', '[data-item-normalcheckout]', function() {
		// when checkout button is triggered
		const cartTerms = $('#cart-terms');

		cartTerms.change(function() {
			$(this).parent().removeClass('error');
		});
			window.location.href = `//${siteShopifyDomain}/checkout`
	});

	// item quantity adjustments
	_document.on('click', '.item-quantity button', function(e) {
		e.preventDefault();

		let _this = $(this);
		let item = _this.closest('.item');
		let itemQuantity = _this.closest('.item-quantity');
		let quantityMax = itemQuantity.attr('data-quantity-max');
		let quantityMin = itemQuantity.attr('data-quantity-min');
		let quantityCurrent = _this.siblings('.item-quantity-current');
		let quantityCurrentVal = parseInt(quantityCurrent.text());
		let quantityAction = _this.hasClass('item-quantity-increase')
			? 'increase'
			: 'decrease';

		// if increase, and isn't max inventory count
		let quantityNewVal = quantityAction == 'increase' && quantityCurrentVal < quantityMax
			// increase quantity
			? quantityCurrentVal + 1
			// else if is decrease and quantity isn't 0
			: quantityAction == 'decrease' && quantityCurrentVal > quantityMin
				// decrease quantity
				? quantityCurrentVal - 1
				// else, stay at current quantity
				: quantityCurrentVal

		// update quantity text and value
		item.find('.item-quantity-current')
			.text(quantityNewVal);

		// trigger ajax update
		if(item.closest('#minicart').length) {
			itemUpdate(item.attr('data-item-id'), quantityNewVal, null);
		}

		// remove item if quantity is 0
		if (quantityNewVal == 0) {
			loadingBarTrigger('move');
			item.remove();
			cartTotalUpdate();
			loadingBarTrigger('done');
		}

		loadingBarTrigger('start');
	});

	// remove item
	_document.on('click', '#minicart-items .item-remove', function(e) {
		e.preventDefault();

		let _this = $(this);
		let item = _this.closest('.item'); 
		let itemTitles = ["outer shell", "outer case add-on", "duo", "trio"];
		let selectedTitle = item.children(".item-content").children(".g-flex").children(".t-heading-s").text().toLowerCase();
		
		// check to see if bundled items and remove
		if(selectedTitle == "outer shell" 
			|| selectedTitle == "outer case add-on"
			|| selectedTitle == "duo"
			|| selectedTitle == "trio"	
		) {
			let allItems = $('.item')
			let itemsQueue = []
			allItems.each((index, item) => {
				for(i = 0; i <= itemTitles.length; i++) {
					if (item.querySelector(".t-heading-s").innerText.toLowerCase() == itemTitles[i]) {
						itemsQueue.push($(item).attr('data-item-id'))
						// itemUpdate($(item).attr('data-item-id'), 0, null);
						item.remove();
					}
				}
			})
			console.log(itemsQueue)
			itemsRemovePost(itemsQueue)
			cartTotalUpdate();
			loadingBarTrigger('done');
		} else {
			loadingBarTrigger('start');

			// remove item div
			item.remove();
			
			// remove all items -- commenting out, not needed
			// clearCart()

			// trigger ajax update
			itemUpdate(item.attr('data-item-id'), 0, null);

			cartTotalUpdate();
			loadingBarTrigger('done');
		}

		
	});


	// when checkout button is triggered
	const cartTerms = $('#cart-terms');

	cartTerms.change(function() {
		$(this).parent().removeClass('error');
	});

	$('#cart-actions-checkout').click(function(e) {
		if(cartTerms.prop('checked') != true) {
			e.preventDefault();
			cartTerms.parent().addClass('error');

			return false;
		}

		if($('.item[data-item-subscription]').length) {
			e.preventDefault();
			checkoutProcessRecharge();
		} else {
			window.location.href = `//${siteShopifyDomain}/checkout`
		}
	});

	// Minicart actions
	minicartTrigger.click(function(e) {
		e.preventDefault();

		html.addClass('minicart_active');
	});

	minicartClose.click(function() {
		html.removeClass('minicart_active');
	});

	// excluded recommended items that are in cart
	excludeRecommendedItems();
}

const initRechargeProducts = () => {
	if(document.querySelector('#shopify-section-products-header-1') != null) {
		//set defaults for main
		let colors = document.querySelectorAll('.color-selections');
		let labels = document.querySelectorAll('.color-option');
		let selection = document.querySelector('h6 #selected-option');
		let addItemBtn = document.querySelector('.add-to-cart');
		let colorsArray = [];
		let labelHighlight = [];
		let colorImgs = [];

		// handle submit errors on default button
		addItemBtn.addEventListener('click', (e) => {
			e.preventDefault();
		})
		
		// push colors
		for (i = 0; i < colors.length; i++) {
			colorsArray.push(colors[i].getAttribute('data-color-code'));
			colorImgs.push(colors[i].getAttribute('data-variant-image'));
			labelHighlight.push(labels[i].children);
		}

		//set default to first option
		addItemBtn.setAttribute('data-quickadd-id', colors[0].getAttribute('data-variant-id'));
		selection.textContent = colors[0].getAttribute('value');
		$(labels[0].children).toggleClass('color-option-selected');
		$(labels[0]).context.previousElementSibling.checked = true
		// = "true";

		// label color from variants, label click listeners for label highlight, update add-to-cart btn
		for(i = 0; i < colors.length; i++) {
			// add colors to labels
			labels[i].style.backgroundColor = colorsArray[i];
			// add click listeners to labels
			labels[i].addEventListener('click', e => {
				let topParent = e.currentTarget.parentNode.parentNode.parentNode
				let selectedProdId = ""
				if (topParent.id == 'main') {
					selectedProdId = topParent.id.toLowerCase()
				} else {
					topParent = topParent.parentNode.parentNode
					selectedProdId = topParent.id.toLowerCase()
				}
				let swatchSelectorDiv = e.target.parentNode.parentNode
				let splitSwatchDiv = swatchSelectorDiv.id.toLowerCase().split('-')
				// if the swatch and not it's child div
				if (e.target.tagName != 'DIV') {
					e.target.previousElementSibling.setAttribute('checked', 'checked')
					// assign swatchs to array
					let swatches = swatchSelectorDiv.querySelectorAll('.color-option')
					const swatchArray = Array.from(swatches)
					// remove all selectors on click
					swatchArray.map((swatch) => {
						const swatchDiv = swatch.children[0]
						if (swatchDiv.classList.value == 'color-option-selected') {
							swatchDiv.classList.remove('color-option-selected')
						}
					})
					// add swatch to clicked
					e.target.children[0].classList.add('color-option-selected')
					// get button, assigning to addItemBtn
					addItemBtn = topParent.querySelector('button')
					addItemBtn.addEventListener('click', e => {
						e.preventDefault()
					})
					// update text content and add to button
					if (selectedProdId != "main") {
						if (splitSwatchDiv.length == 2) {
							selection = document.querySelector(`h6 #selected-option-${selectedProdId}`);
							addItemBtn.setAttribute('data-quickadd-id', e.target.previousElementSibling.getAttribute('data-variant-id'))
						} else if (splitSwatchDiv.length == 5){
							selection = document.querySelector(`h6 #selected-option-${selectedProdId}-add-on-${splitSwatchDiv[3]}`)
							addItemBtn.setAttribute(`data-quickadd-other-${splitSwatchDiv[3]}`, e.target.previousElementSibling.getAttribute('data-variant-id'))
						}
						
					} else {
						selection = document.querySelector('h6 #selected-option');
					
					if (! document.querySelector('#engraving-hidden')) { /* only color variants, use old code */
						addItemBtn.setAttribute('data-quickadd-id', e.target.previousElementSibling.getAttribute('data-variant-id'))
					} else { /* color+engraving variants have been set up */
						var c_val = e.target.previousElementSibling.getAttribute('value');
						var e_val = document.querySelector('#engraving-hidden').value;
						findSetVariant(c_val, e_val);
					}
					}
					if (addItemBtn.previousElementSibling.textContent != "") {
						addItemBtn.previousElementSibling.textContent = ""
						addItemBtn.addEventListener('click', e => {
							e.preventDefault()
						})
					}
					selection.textContent = e.target.previousElementSibling.getAttribute('value')
				}
			})

			// -- Change Variant Images --
			// initialize variant slideshow
			window.addEventListener('load', (e) => {
				let carousel = $('.variant-slideshow').flickity({
					accessibility: true,
					resize: false,
					wrapAround: true,
					prevNextButtons: false,
					pageDots: true,
					percentPosition: true,
					setGallerySize: true,
					draggable: true
				})
				let defaultImages = Object.values(getInfo(0).images);
				let defaultVideos = Object.values(getInfo(0).youtube);
				let cellElements = carousel.flickity('getCellElements')
				// remove images
				if( cellElements ){
					carousel.flickity( 'remove', cellElements )
				}
				// make slides based on type
				if(defaultImages != null) {
					for (i = 0; i < defaultImages.length; i++) {
						newCell = makeCell("image", defaultImages[i].src, defaultImages[i].alt)
						carousel.flickity( 'append', newCell )
					}
				}
				
				if (defaultVideos != null) {
					for (i = 0; i < defaultVideos.length; i++) {
						newCell = makeCell("youtube", defaultVideos[i].external_id, defaultVideos[i].alt)
						carousel.flickity( 'append', newCell )
					}
				}
			})

			// add images to slider
			labels[i].addEventListener('click', (e) => {
				// return if not main, else change slideshow images
				if (e.target.parentNode.parentNode.parentNode.id.toLowerCase() != 'main') {
					return
				} else {
					let selectedNum = e.target.previousElementSibling.getAttribute('data-index').slice(-1);
					selectedNum = parseInt(selectedNum) - 1;
					let variantImages = Object.values(getInfo(selectedNum).images);
					let variantVideos = Object.values(getInfo(selectedNum).youtube);
					// get carousel and slide count
					let carousel = $('.variant-slideshow').flickity()
					let cellElements = carousel.flickity('getCellElements')
					// remove images
					if( cellElements ){
						carousel.flickity( 'remove', cellElements )
					}
					// set images and video
					let newCell;
					console.log(variantImages)
					console.log(variantVideos)
					for (i = 0; i < variantImages.length; i++) {
						newCell = makeCell("image", variantImages[i].src, variantImages[i].alt)
						carousel.flickity( 'append', newCell )
					}
					for (i = 0; i < variantVideos.length; i++) {
						newCell = makeCell("youtube", variantVideos[i].external_id, variantVideos[i].alt)
						carousel.flickity( 'append', newCell )
					}
					carousel.flickity( 'select', 0 )
				}
			});
		}

		// make flickity slides
		function makeCell(type, src, alt) {
			if (type === "image") {
				let cell = document.createElement('div');
				cell.className = 'flickity-cell';
				let image = document.createElement('img');
				image.src = src;
				image.srcset = src;
				image.alt = alt;
				cell.appendChild(image);
				return cell;
			} else {
				let cell = document.createElement('div');
				cell.className = 'flickity-cell video-wrap';
				let embedVid = {"video": {
					"value": `<iframe title='YouTube video player' type=\"text/html\" alt=${alt} width='640' height='390' src='http://www.youtube.com/embed/${src}'frameborder='0' allowFullScreen></iframe><div class="video-wrap__grippy"></div><div class="video-wrap__grippy"></div>`
				}};
				cell.innerHTML = embedVid.video.value;
				return cell;
			}
		}

		// filter img info
		function getInfo(id) {
			// get media for variant
			const variant = document.getElementById('main').getElementsByClassName("color-selections")[id].value.toLowerCase();
			const media = JSON.parse(document.getElementById("productinfo").text).media;
			// filter for youtube videos or images
			const filteredYoutube = media.reduce(
				(a, c) => (c.host === "youtube" 
					? (c.alt == variant && a.push({"external_id": c.external_id, "alt": c.alt, "type": "youtube"}))
					: (null), a), []
				)
			const filteredImages = media.reduce(
				(a, c) => (c.src !== undefined 
					? (c.alt == variant && a.push({"src": c.src, "alt": c.alt, "type": "image"}))
					: (null), a), []
				)
			// join objects and return
			const returnObject = {
				images: {...filteredImages},
				youtube: {...filteredYoutube}
			}
			return(returnObject);
		}
	}
}

const initAccounts = () => {
	const recoverFormClick = $('#recover-form_click');

	recoverFormClick.click(function(e){
		e.preventDefault();

		location.hash = '#recover';
		$('#login-form').slideUp(150);
		$('#recover-form').slideDown(150);
	});

	if(window.location.hash == '#recover'){
		recoverFormClick.trigger('click')
	}

	$('.orders-list ul').click(function(e) {
		e.preventDefault();
		let order = $(this);

		order.toggleClass('active').siblings('.order-details').slideToggle(200);
		order.parent().siblings().children('ul').removeClass('active');
		order.parent().siblings().children('.order-details').slideUp(200);
	});
}

const initBlogIndex = () => {
	const blogSearch = $('#blog-search');
	const blogSearchTrigger = blogSearch.find('#search-trigger');

	blogSearchTrigger.click(function() {
		blogSearch.addClass('active');

		$('#search-input').focus();
	});

	_window.click(function(e) {
		let target = $(e.target);

		if(!target.is('#blog-search') && 
			!target.closest('#blog-search')) {
			blogSearch.removeClass('active');
		}
	});

	if(screenIsMobile) {
		$(`#blog-featured #featured-article, 
			#blog-popular .article-popular`).remove();
	} else {
		$(`#blog-featured .article, 
			#blog-popular .article`).remove();
	}
}

const initBlogSingle = () => {
	_document.on('click', '#article-share-url', function() {
		let _this = $(this);
		let shareUrlSpan = _this.find('span');
		let urlInput = document.createElement('input');

		document.body.appendChild(urlInput);
		urlInput.value = window.location.href;
		urlInput.select();
		document.execCommand('copy');
		document.body.removeChild(urlInput);

		shareUrlSpan.text('Copied!');

		setTimeout(function() {
			shareUrl.mouseleave(function() {
				shareUrlSpan.text('Copy article URL');
			});
		}, 200);
	});

	if(screenIsTablet) {
		$('#article-share').remove().clone()
			.insertAfter('#article-content .content');
	}
}

const initPhilosophyPage = () => {
	const contentLeftImagesImage = $('#content-left-images .image');

	contentLeftImagesImage.show();

	const philosophyScroll = () => {
		contentLeftImagesImage.each(function(i) {
			let _this = $(this);

			_this.css({
				'-webkit-transform': `translateY(${scrollTop/2}px)`,
				'transform': `translateY(${scrollTop/2}px)`
			})

		});
	}
	philosophyScroll();
	_window.scroll(philosophyScroll);

}

// 4.0 INIT APP

initPageTransition();
initFields();
initHeader();
activateDropdown();
activateSecondaryDropdown();
initProductQuickview();
initCart();

switch(html.attr('id')) {
	case 'frontpage':
		initFrontpage();
		break;

	case 'product-index':
		productIndex();
		break;

	case 'accounts':
		initAccounts();
		break;

	case 'blog-index': 
		initBlogIndex();
		break;

	case 'blog-single':
		initBlogSingle();
		break;

	case 'page-hormone-health':
		initPhilosophyPage();
		break;

	case 'product-single':
		initRechargeProducts();
		break;
}

initCompMarquee();
initCompFlipboard();
initCompSlider();
initCompToggle();

$('[data-scroll-to]').click(function() {
	scrollTo($(this).attr('data-scroll-to'));
});

$('.video').fitVids();

_window.resize(function() {
	if ((!screenIsTablet && _window.width() < 1024) || 
		(screenIsTablet && _window.width() >= 1024) ||
		(!screenIsMobile && _window.width() < 600) || 
		(screenIsMobile && _window.width() >= 600)) {
		body.addClass('css_fadeOut');
		location.reload();
	}
});

//  swiping fix for IOS
(function() {
	var touchingCarousel = false,
		touchStartCoords;

	document.body.addEventListener('touchstart', function(e) {
		if (e.target.closest('.flickity-slider')) {
			touchingCarousel = true;
		} else {
			touchingCarousel = false;
			return;
		}

		touchStartCoords = {
			x: e.touches[0].pageX,
			y: e.touches[0].pageY
		}
	});

	document.body.addEventListener('touchmove', function(e) {
		if (!(touchingCarousel && e.cancelable)) {
			return;
		}

		var moveVector = {
			x: e.touches[0].pageX - touchStartCoords.x,
			y: e.touches[0].pageY - touchStartCoords.y
		};

		if (Math.abs(moveVector.x) > 7)
			e.preventDefault()

	}, {passive: false});
})();

